import { ComponentSize } from '../../../types';

/** Mapping of avatar sizes to corresponding width values. */
export const AVATAR_SIZE_TO_WIDTH: Record<ComponentSize, number> = {
  [ComponentSize.X_SMALL]: 24,
  [ComponentSize.SMALL]: 32,
  [ComponentSize.MEDIUM]: 48,
  [ComponentSize.LARGE]: 80,
};
